<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"></h4>
                        <p class="category"></p>
                    </div>

                    <div class="container-fluid">
                        <div class="instructionsHeader">
                            <div class="text-right">
                                <i [routerLink]="['/app/rassessment', id]" class="rotate180 large material-icons">keyboard_backspace</i>
                            </div>
                            <h3>Assessments</h3>
                            <h4>Instructions</h4>
                        </div>

                        <div>
                            <p class="raterName">Hello, {{raterName}}.</p>
                            <br />
                            <p>
                                Thank you for participating in iPEC's 360 assessment process. 
                                Please fill out the following questions with regard to Mary Parker.  
                                We ask that you carefully consider your answers and that you be as honest as possible so that the person being rated can benefit from the process. 
                                Your responses will be combined with other responses and represented as an average. 
                                Your individual responses and your name are not identified in Feedback Report. 
                                If a particular question does not apply because of your relationship to the person you are rating, please leave it blank.
                            </p> 
                            <br /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
